import * as moment from "moment";

const NULL_DURATION = Object.freeze({ hours: 0, minutes: 0, seconds: 0 });

export const oxygenDurationDataFromSeconds = (seconds) => {
  if (!seconds) {
    return NULL_DURATION;
  }

  const duration = moment.duration(seconds, "seconds");
  return {
    hours: duration.hours(),
    minutes: duration.minutes(),
    seconds: duration.seconds(),
  };
};

export const oxygenDurationDataToSeconds = (durationData) => {
  const seconds = durationData?.seconds ?? 0;
  const minutes = durationData?.minutes ?? 0;
  const hours = durationData?.hours ?? 0;
  return hours * 3600 + minutes * 60 + seconds;
};
